// src/utils/avatarColor.js
export const COLORS = [
  "#007bff", "#28a745", "#ffc107", "#17a2b8", "#6f42c1",
  "#fd7e14", "#e83e8c", "#20c997", "#6610f2", "#343a40",
  "#ff6f61", "#00bcd4", "#9c27b0", "#8bc34a", "#ff9800",
  "#795548", "#3f51b5", "#009688", "#cddc39", "#607d8b",
];

export function getUserColor(userId) {
  const hash = userId
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return COLORS[hash % COLORS.length];
}

export function getInitials(name) {
  return name
    ? name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "?";
}
